var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"}));
}

Star.defaultProps = {"fill":"currentColor","viewBox":"0 0 20 20"};

module.exports = Star;

Star.default = Star;
